import { render, staticRenderFns } from "./StatButton.vue?vue&type=template&id=1925664f&"
import script from "./StatButton.vue?vue&type=script&lang=js&"
export * from "./StatButton.vue?vue&type=script&lang=js&"
import style0 from "./StatButton.vue?vue&type=style&index=0&id=1925664f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports